export const calcGapY = (state) => {
  if (window.innerWidth < 440) {
    return (204 - 39 * 3) / 4;
  }

  if (window.innerWidth >= 440 && window.innerWidth < 736) {
    return (248 - 39 * 3) / 4;
  }

  if (window.innerWidth >= 736 && window.innerWidth < 1024) {
    return (260 - 39 * 3) / 4;
  }

  if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
    if (state) {
      return (286 - 39 * 3) / 4;
    } else {
      return (354 - 49 * 3) / 4;
    }
  }

  if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
    if (state) {
      return (364 - 50 * 3) / 4;
    } else {
      return (446 - 69 * 3) / 4;
    }
  }

  return state
    ? (448 - 70 * 3) / 4
    : (538 - 89 * 3) / 4;
};

const getMixedFraction = (level) => {
  const maxDenominator =
    level === "beginner"
      ? 5
      : level === "advanced"
      ? 20
      : 10;

  const denominator =
    Math.floor(Math.random() * (maxDenominator - 1)) + 2;

  const whole =
    level === "beginner"
      ? Math.floor(Math.random() * 3) + 1
      : level === "advanced"
      ? Math.floor(Math.random() * 6) + 1
      : Math.floor(Math.random() * 4) + 1;

  const numerator =
    Math.floor(Math.random() * (denominator - 1)) + 1;

  return `${whole} ${numerator}/${denominator}`;
};

const toImproperFraction = (mixedFraction) => {
  const [whole, fraction] = mixedFraction.split(" ");
  const [num, den] = fraction.split("/").map(Number);

  return `${Number(whole) * den + num}/${den}`;
};

export const TopPartNumbers = (level) => {
  return [getMixedFraction(level)];
};

export const getNumbers = (level) => {
  const fraction = getMixedFraction(level);

  return [[fraction]];
};

export const getAnswer = (arr1) => {
  return toImproperFraction(arr1[0]);
};

export const getAnswers = (correctAnswer) => {
  const [num, den] = correctAnswer.split("/").map(Number);

  const answers = new Set();
  answers.add(correctAnswer);

  while (answers.size < 3) {
    const fakeNum =
      Math.max(
        1,
        num + Math.floor(Math.random() * 5) - 2
      );

    answers.add(`${fakeNum}/${den}`);
  }

  return [...answers].sort(() => Math.random() - 0.5);
};

export const getAnimationValues = () => {
  const values = [Math.random() * 100];

  while (values.length < 5) {
    values.push(
      Math.random() * 100 +
        values[values.length - 1]
    );
  }

  return values;
};

export const getBottomGapX = (state) => {
  if (window.innerWidth < 440) {
    return (300 - 5 * 39) / 3;
  }

  if (window.innerWidth >= 440 && window.innerWidth < 736) {
    return (400 - 5 * 39) / 3;
  }

  if (window.innerWidth >= 736 && window.innerWidth < 1024) {
    return (425 - 5 * 39) / 3;
  }

  if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
    return state
      ? (439 - 6 * 39) / 3
      : (576 - 6 * 49) / 3;
  }

  if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
    return state
      ? (590 - 6 * 50) / 3
      : (723 - 6 * 69) / 3;
  }

  return state
    ? (768 - 6 * 70) / 3
    : (909 - 6 * 89) / 3;
};

export const getCoordinates = () => {
  const elem = document.querySelector(".adding");
  const answer = document.querySelector(".answer");

  const x1 = elem.getBoundingClientRect().x;
  const y1 = elem.getBoundingClientRect().y;

  const x2 = answer.getBoundingClientRect().x;
  const y2 = answer.getBoundingClientRect().y;

  const xDistance = x1 - x2;
  const yDistance = y1 - y2;

  return [
    xDistance -
      (answer.getBoundingClientRect().width -
        elem.getBoundingClientRect().width) /
        2,

    yDistance -
      (answer.getBoundingClientRect().height -
        elem.getBoundingClientRect().height) /
        2,
  ];
};